<header>
  <nav *ngIf="nav.visible" class="navbar navbar-header navbar-expand-md menu-header menu-bar navbar-default navbar-light menu-shadow">
    <button class="navbar-toggler collapsed" type="button" (click)="toggleNavs('appMenu')" [attr.aria-expanded]="!appMenuCollapsed"
        aria-controls="appMenu" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>
    <a class="navbar-brand" href="javascript:void(0)" (click)="navigateHome()" routerLinkActive="active">
      <img src="assets/images/MatrixCare_Logo.svg" alt="MatrixCare Logo" />
    </a>
    <button class="navbar-toggler navbar-toggler-right" type="button" (click)="toggleNavs('userMenu')" [attr.aria-expanded]="!userMenuCollapsed"
        aria-controls="navbarCollapse" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"><i class="fa fa-user"></i></span>
    </button>
    <div class="collapse navbar-collapse menu-header-menu" id="appMenu" [ngbCollapse]="!appMenuCollapsed">
      <ul class="nav ml-0"  *ngIf="isAuthenticated">
        <!--<li class="nav-item" *ngIf="isAuthenticated && isUserManagementAdmin">
    <a routerLink="/users" class="nav-link" routerLinkActive="active" (click)="closeNavs()">
      User Management
    </a>
  </li>-->

        <li class="nav-item dropdown" routerLinkActive="active" *ngIf="isAuthenticated && (isUserManagementAdmin || isCorporateLimitedAdmin || isUserLocationLimitedAdmin)">
          <div ngbDropdown class="d-block" placement="bottom-left">
            <a href="javascript:" class="nav-link" id="userManagementDropdown" ngbDropdownToggle>User Management</a>
            <div ngbDropdownMenu aria-labelledby="userManagementDropdown">
	              <a class="dropdown-item" [routerLink]="['/users']" (click)="closeNavs()">User List</a>
	              <!--TODO  We need a better way to handle separator visibility. Like checking previous and next sibillings -->
	              <hr class="line-separator" *ngIf="(!isCorporateLimitedAdmin || isUserManagementAdmin) && (customerSettingsService.getSettings() | async)?.customerEnabledMFA && !isUserLocationLimitedAdmin">
	              <a class="dropdown-item" [routerLink]="['/2fa-bulk-update']" (click)="closeNavs()" *ngIf="isManageRulesUser && (customerSettingsService.getSettings() | async)?.customerEnabledMFA">2FA Bulk Update</a>
              <a class="dropdown-item" [routerLink]="['/transaction-log']" (click)="closeNavs()" *ngIf="!isCorporateLimitedAdmin && !isUserLocationLimitedAdmin">Transaction Log</a>
            </div>
          </div>
        </li>

            <li class="nav-item dropdown" routerLinkActive="active" *ngIf="isAuthenticated && showEnvironmentConfigTool && (isEctAdminEmployee || isEctUserEmployee || isEctReadOnlyUser)">
                <div ngbDropdown class="d-block" placement="bottom-left">
                    <a href="javascript:" class="nav-link" id="environmentConfigurationDropdown" ngbDropdownToggle>Enterprise Configuration</a>
                    <div ngbDropdownMenu aria-labelledby="environmentConfigurationDropdown">
                        <a class="dropdown-item" [routerLink]="['/ect/stacks/detail']" (click)="closeNavs()" *ngIf="isEctUserEmployee || isEctReadOnlyUser">Stack</a>
                        <a class="dropdown-item" [routerLink]="['/ect/customers']" (click)="closeNavs()" *ngIf="isEctUserEmployee || isEctReadOnlyUser">Customers</a>
                        <a class="dropdown-item" [routerLink]="['/ect/configurations']" (click)="closeNavs()" *ngIf="isEctUserEmployee || isEctReadOnlyUser">Configurations</a>
                        <a class="dropdown-item" [routerLink]="['/ect/parameters']" (click)="closeNavs()" *ngIf="isEctUserEmployee || isEctReadOnlyUser"> Parameters</a>
                        <a class="dropdown-item" [routerLink]="['/ect/administration']" (click)="closeNavs()" *ngIf="isEctAdminEmployee">Administration</a>
                    </div>
                </div>
            </li>
            <li class="nav-item" *ngIf="isAuthenticated && isServiceLogAdmin">
                <a routerLink="/servicelogs" class="nav-link" routerLinkActive="active" (click)="closeNavs()">
                    Log Viewer
                </a>
            </li>
            <li class="nav-item dropdown" routerLinkActive="active" *ngIf="isAuthenticated && (isResDocMigrateUser || isProfileSyncUser || isSnfLegacyListUser)">
                <div ngbDropdown class="d-block" placement="bottom-left">
                    <a href="javascript:" class="nav-link" id="userDropDownConvUtil" ngbDropdownToggle>Conversion Utilities</a>
                    <div ngbDropdownMenu aria-labelledby="userDropDownConvUtil">
                        <a class="dropdown-item" [routerLink]="['/conversions/resident-doc-move']" (click)="closeNavs()" *ngIf="isResDocMigrateUser">Resident Document Migration</a>
                        <a class="dropdown-item" [routerLink]="['/conversions/profile-sync']" (click)="closeNavs()" *ngIf="isProfileSyncUser">Sync MatrixCare 360 access profile</a>
                        <a class="dropdown-item" [routerLink]="['/conversions/snf-legacy-user-import-list']" (click)="closeNavs()" *ngIf="isSnfLegacyListUser">MatrixCare 360 Legacy to IDM</a>
                        <a class="dropdown-item" [routerLink]="['/conversions/keycloak-user-import-list']" (click)="closeNavs()" *ngIf="isKeycloakListUser">Keycloak to IDM</a>
                        <a class="dropdown-item" [routerLink]="['/conversions/import-users-list']" (click)="closeNavs()" *ngIf="isImportUsers">Import Users</a>
                    </div>
                </div>
            </li>
            <li class="nav-item dropdown" routerLinkActive="active" *ngIf="isAuthenticated && isTokenManagerUser">
                <a routerLink="/tokenManagement" class="nav-link" routerLinkActive="active" (click)="closeNavs()">
                    Token Management
                </a>
            </li>
            <li class="nav-item" *ngIf="isAuthenticated  && isReportsUser">
                <a routerLink="/reports" class="nav-link" routerLinkActive="active" (click)="closeNavs()">
                    Reports
                </a>
            </li>
            <li class="nav-item dropdown" routerLinkActive="active" >
                <div ngbDropdown class="d-block" placement="bottom-left">
                    <a href="javascript:" class="nav-link" id="configurationDropdown" ngbDropdownToggle>Configuration</a>
                    <div ngbDropdownMenu aria-labelledby="configurationDropdown">
                      <a class="dropdown-item" [display-if]="isManageIPUser" [routerLink]="['/configuration/manage-ip']" (click)="closeNavs()">Maintain IP Lists</a>
                      <a class="dropdown-item" [display-if]="isManageRulesUser" [routerLink]="['/configuration/policies']" (click)="closeNavs()">Manage SignOn Policies</a>
                      <a class="dropdown-item" [display-if]="isManage2FactorAuthentication" [routerLink]="['/configuration/mfa']" (click)="closeNavs()">Two-Factor Authentication</a>
                      <hr class="line-separator" [display-if]="(isManageIPUser || isManageRulesUser || isManage2FactorAuthentication) && (isCustomerAdmin)">
                      <a class="dropdown-item" [display-if]="isCustomerAdmin" [routerLink]="['/configuration/settings']" (click)="closeNavs()">Security Settings</a>
                      <hr class="line-separator" [display-if]="checkForMappingSeperator">
                      <a class="dropdown-item" [display-if]="isMapping" [routerLink]="['/configuration/mapping/locations']" (click)="closeNavs()">MatrixCare 360 Location Mapping</a>
                      <a class="dropdown-item" [display-if]="isMapping" [routerLink]="['/configuration/mapping/access']" (click)="closeNavs()">MatrixCare 360 Access Mapping</a>
                    </div>
                </div>
            </li>
        <li class="nav-item dropdown" routerLinkActive="active">
          <div ngbDropdown class="d-block" placement="bottom-left">
            <a href="javascript:" class="nav-link" id="sharedLoginDropdown" ngbDropdownToggle>Shared Login</a>
            <div ngbDropdownMenu aria-labelledby="sharedLoginDropdown">
              <a class="dropdown-item" [display-if]="isIdpAdmin" [routerLink]="['/shared-login/applications']" (click)="closeNavs()">Applications</a>
              <a class="dropdown-item" [display-if]="canManageSessions" [routerLink]="['/shared-login/sessions']" (click)="closeNavs()">Sessions</a>
              <a class="dropdown-item" [display-if]="canManageSessions" [routerLink]="['/shared-login/sessions/audit']" (click)="closeNavs()">Audit</a>
            </div>
          </div>
        </li>
            <li class="nav-item" *ngIf="isAuthenticated && showMyProfile">
                <a routerLink="/my-profile" class="nav-link" routerLinkActive="active" (click)="closeNavs()">
                    My Profile
                </a>
            </li>
        </ul>
    </div>
    <div class="collapse navbar-collapse" id="navbarCollapse" [ngbCollapse]="!userMenuCollapsed">
      <!-- <li class="nav-item">
    <a [routerLink]="['/help']" class="nav-link nav-icon">
      <i class="fa fa-question-circle-o"></i>
    </a>
  </li> -->
      <!-- <li class="nav-item mega">
  </li> -->
      <ul class="navbar-nav ml-auto mr-auto" *ngIf="isAuthenticated ">

        <li class="nav-item" *ngIf="isViewCustomer">
          <div class="nav-link ">
            <span>Select Customer:</span>
            <a (click)="changeCustomer()" class="link" [routerLink]="[]"> {{selectedCustomer||'No Customer selected'}}</a>
          </div>
        </li>
        <li class="nav-item dropdown">
          <div ngbDropdown class="d-block" placement="bottom-right" display="dynamic">



            <a href="javascript:" class="nav-link text-right" id="userDropDown" ngbDropdownToggle>{{fullName}}</a>
            <div ngbDropdownMenu aria-labelledby="userDropDown">
              <ng-template [ngIf]="showMyProfile" [ngIfElse]="dontShowMyProfile">
                <a class="dropdown-item" *ngIf="!isFederatedUser" routerLink="/my-profile" (click)="closeNavs()">Change Password</a>
              </ng-template>
              <ng-template #dontShowMyProfile>
                <a class="dropdown-item" href="{{changePasswordUrl}}" target="_blank" (click)="closeNavs()">Change Password</a>
              </ng-template>
              <!-- <a class="dropdown-item" target="_blank" [routerLink]="['/help']">Help</a> -->
              <a class="dropdown-item" [routerLink]="['/about']" (click)="closeNavs()">About</a>
              <a class="dropdown-item" href="javascript:" (click)="logout()">{{(isFederatedUser && isDuoCustomer) ? 'Log off Duo' : 'Log off' }}</a>
            </div>
          </div>
        </li>
      </ul>
    </div>
  </nav>
</header>
